export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
export const metaImage = process.env.REACT_APP_BASE_URL + '/media/logos/logo_eafruits.png'

